import { render, staticRenderFns } from "./AppLoadVue.vue?vue&type=template&id=cb521a88"
import script from "./AppLoadVue.vue?vue&type=script&lang=js"
export * from "./AppLoadVue.vue?vue&type=script&lang=js"
import style0 from "./AppLoadVue.vue?vue&type=style&index=0&id=cb521a88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports